<template>
  <div>
    <Layout>
      <div class="container">
        <div class="pagedata" v-html="pageData"></div>
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from "@/views/public/layout";
import config from "@/config";
export default {
  data() {
    return {
      imageUrl: config.pageData.aboutArticle.img,
    };
  },
  methods: {},
  computed: {
    pageData() {
      const language = this.$i18n.locale;
      if (language === "cn") {
        return config.pageData.aboutArticle.content;
      } else {
        return config.pageData.aboutArticle.enContent;
      }
    },
  },
  components: {
    Layout,
  },
  created() {},
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "index";
</style>
